export enum ButtonNames {
  Submit = 'Save & Submit',
  Recall = 'Recall',
  Save = 'Save',
  Yes = 'Yes',
  No = 'No',
  DiscardChanges = 'Discard Changes',
  Reopen = 'Reopen',
  Ok = 'OK',
  SaveAllChanges = 'Save All Changes',
  DiscardAllChanges = 'Discard All Changes'
}

export enum ButtonColors {
  Primary = 'primary',
  Accent = 'accent',
  Warn = 'warn'
}
